// extracted by mini-css-extract-plugin
export default {"notfound":"notFound_notfound__gCxdb","notfoundButton":"notFound_notfoundButton__U0-MU","notfound404":"notFound_notfound404__x6xdD","notfoundSearch":"notFound_notfoundSearch__e6F0J"};